import loader from "../../img/icon_loader.svg";
import "../../css/login.scss";

let loginWithToken = {
  _loginCallback: function(userKey, roll, type) {
    if (userKey != null) {
      location.reload();
    }
  },
  _logoutCallback: function(result) {
    if (result === true) {
      location.reload();
    }
  },
  /**
   * ログイン（OIDC経由）
   */
  _loginWithToken: async function() {
    try {
      // ログインAPIリクエストを送信
      const results = await window.FMS.oidc.fetch(new URL('/wp-json/api/v1/loginWithToken', window.location.origin).href, {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json",
        },
        fms: {
          "authorizationHeader": "accessToken" 
        },
        body: JSON.stringify({})
      });

      const data = results;
      if (data['loginFlag'] === true) {
        console.log(JSON.stringify(data));
        this._loginCallback(data['userKey'], data['role'], data['type']);
        return;
      }

      alert('メールアドレスまたはパスワードが間違っています。'); // TODO 仮
    
      this._loginCallback(null, null, null);
    } catch (error) {
      this._loginCallback(null, null, null);
      if (error.responseJSON && error.responseJSON.error) {
        throw new Error(error.responseJSON.error);
      } else {
        throw new Error(error);
      }
    } finally {
      // TODO ローディング中表示を消す
    }
  },

  /**
   * ログアウト(OIDC経由)
   */
  _logoutWithToken: async function() {
    try {
      await window.FMS.oidc.logout();
      const results = await $.ajax({
        type: 'POST',
        url: "/wp-json/fms/v1/session/logout",
        cache: false,
      });

      if (results['success'] === true) {
        this._logoutCallback(results['success']);
      } else {
        this._logoutCallback(false);
      }
    } catch (error) {
      this._logoutCallback(false);
      if (error.responseJSON && error.responseJSON.error) {
        throw new Error(error.responseJSON.error);
      } else {
        throw new Error(error);
      }
    }
  },

  /**
   * OIDCログインの呼び出し
   */
  _login: async function() {
    // 現在のURLを取得し、クエリストリングに追加
    const redirectUrl = `${window.location.origin}/update-session?redirect_to=${encodeURIComponent(location.href)}`;
    window.FMS.oidc.login(redirectUrl);
  }
};

export default loginWithToken;
